import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

/** Shared presentation primitives for the case file. */
export const btn = "rounded-none bg-blue-900 hover:bg-blue-800 text-white uppercase tracking-widest text-xs h-10";

export const Section = ({ title, children, form, testId }) => (
  <div className="border border-border bg-card" data-testid={testId}>
    <div className="px-6 py-4 border-b border-border"><p className="label-caps">{title}</p></div>
    {form && <div className="px-6 py-5 border-b border-border bg-muted/40">{form}</div>}
    <div>{children}</div>
  </div>
);

export const Row = ({ label, value }) => (
  <div className="px-6 py-4 border-b border-border last:border-0 flex flex-col sm:flex-row sm:items-baseline gap-1 sm:gap-6">
    <p className="label-caps sm:w-48 shrink-0">{label}</p>
    <p className="text-sm">{value || "—"}</p>
  </div>
);

export const F = ({ label, value, onChange, type = "text", required, testId, placeholder }) => (
  <div className="space-y-2">
    <Label className="label-caps">{label}</Label>
    <Input data-testid={testId} type={type} required={required} value={value} placeholder={placeholder}
      onChange={(e) => onChange(e.target.value)} className="rounded-none h-10" />
  </div>
);
